import { PlanDocumentItem } from '../types';
import {api} from './api';

export const planDocumentsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		planDocumentsFindByPlanId: builder.query<PlanDocumentItem[], number>({
			query: (planId: number) => ({
				url: `planDocuments/findByPlanId/${planId}`,
				method: 'GET',
			}),
			providesTags: ['PlanDocuments'],
		}),
		planDocumentUpload: builder.mutation({
			query: (formData: FormData) => ({
				url: 'planDocuments/upload',
				method: 'POST',
				body: formData,
			}),
			invalidatesTags: ['PlanDocuments'],
		}),
		planDocumentDelete: builder.mutation({
			query: (id: number) => ({
				url: `planDocuments/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['PlanDocuments'],
		}),
		planDocumentUpdate: builder.mutation({
			query: ({id, formData}: {id: number, formData: FormData}) => ({
				url: `planDocuments/${id}`,
				method: 'PATCH',
				body: formData,
			}),
			invalidatesTags: ['PlanDocuments'],
		}),
	}),
});

export const { usePlanDocumentUploadMutation, usePlanDocumentDeleteMutation, usePlanDocumentsFindByPlanIdQuery, usePlanDocumentUpdateMutation } = planDocumentsApi;
